import { useState, useEffect } from "react";
import { AuthProvider, useAuth } from "./AuthContext";
import { api, setToken } from "./api";
import Login from "./pages/Login";
import CambioPassword from "./pages/CambioPassword";
import NuovoPreventivo from "./pages/NuovoPreventivo";
import Archivio from "./pages/Archivio";
import GestioneUtenti from "./pages/GestioneUtenti";
import Approvazioni from "./pages/Approvazioni";
import Impostazioni from "./pages/Impostazioni";
import Dashboard from "./pages/Dashboard";
import Profilo from "./pages/Profilo";
import Catalogo from "./pages/Catalogo";
import Promozioni from "./pages/Promozioni";
import "./App.css";

// Colori ruolo per badge sidebar
const RUOLO_BADGE = {
  admin:        { bg: "rgba(231,82,30,0.2)",  color: "#E7521E" },
  dirigente:    { bg: "rgba(255,255,255,0.15)", color: "rgba(255,255,255,0.9)" },
  responsabile: { bg: "rgba(255,255,255,0.12)", color: "rgba(255,255,255,0.8)" },
  venditore:    { bg: "rgba(255,255,255,0.10)", color: "rgba(255,255,255,0.7)" },
  readonly:     { bg: "rgba(255,255,255,0.08)", color: "rgba(255,255,255,0.5)" },
};

function NavSep() {
  return <div className="nav-sep" />;
}

function Shell() {
  const { utente, token, logout, isAuth, cambioPasswordObbligatorio } = useAuth();
  const [pagina, setPagina]   = useState("dashboard");
  const [approvPendenti, setApprovPendenti] = useState(0);
  const [logoUrl, setLogoUrl] = useState(null);

  useEffect(() => { if (token) setToken(token); }, [token]);

  // Carica logo aziendale
  useEffect(() => {
    if (!token) return;
    const url = api.getLogoUrl();
    // Verifica che il logo esista
    fetch(url, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => { if (r.ok) setLogoUrl(url); })
      .catch(() => {});
  }, [token]);

  // Polling approvazioni
  useEffect(() => {
    if (!utente) return;
    if (!["admin","dirigente","responsabile"].includes(utente.ruolo)) return;
    const fetch = () => api.approvPendenti().then(d => setApprovPendenti(d.length)).catch(() => {});
    fetch();
    const t = setInterval(fetch, 60000);
    return () => clearInterval(t);
  }, [utente]);

  if (!isAuth) return <Login />;
  if (cambioPasswordObbligatorio) return <CambioPassword />;

  const puo = (...ruoli) => ruoli.includes(utente?.ruolo);
  const badge = RUOLO_BADGE[utente?.ruolo] || RUOLO_BADGE.readonly;

  return (
    <div className="app-shell">
      <nav className="sidebar">

        {/* Logo + nome app */}
        <div className="sidebar-logo">
          {logoUrl
            ? <img src={logoUrl} alt="Logo aziendale" />
            : <div className="sidebar-logo-placeholder">📄</div>}
          <div className="logo-app-name">Gestione Preventivi</div>
        </div>

        {/* Navigazione */}
        <div className="sidebar-nav">
          <button className={`nav-item ${pagina === "dashboard" ? "active" : ""}`} onClick={() => setPagina("dashboard")}>
            <span>📊</span> Dashboard
          </button>

          {puo("admin","dirigente","responsabile","venditore") && (
            <button className={`nav-item ${pagina === "nuovo" ? "active" : ""}`} onClick={() => setPagina("nuovo")}>
              <span>✏️</span> Nuovo preventivo
            </button>
          )}

          <button className={`nav-item ${pagina === "archivio" ? "active" : ""}`} onClick={() => setPagina("archivio")}>
            <span>🗂️</span> Archivio
          </button>

          {puo("admin","dirigente","responsabile") && (
            <button className={`nav-item ${pagina === "approvazioni" ? "active" : ""}`} onClick={() => setPagina("approvazioni")}>
              <span>⏳</span> Approvazioni
              {approvPendenti > 0 && (
                <span style={{ marginLeft:"auto", background:"#E7521E", color:"white", borderRadius:10, padding:"1px 7px", fontSize:10, fontWeight:800 }}>
                  {approvPendenti}
                </span>
              )}
            </button>
          )}

          <NavSep />

          {puo("admin","dirigente") && (<>
            <button className={`nav-item ${pagina === "catalogo" ? "active" : ""}`} onClick={() => setPagina("catalogo")}>
              <span>📦</span> Catalogo
            </button>
            <button className={`nav-item ${pagina === "promozioni" ? "active" : ""}`} onClick={() => setPagina("promozioni")}>
              <span>🎁</span> Promozioni
            </button>
            <NavSep />
          </>)}

          <button className={`nav-item ${pagina === "profilo" ? "active" : ""}`} onClick={() => setPagina("profilo")}>
            <span>👤</span> Il mio profilo
          </button>

          {puo("admin") && (<>
            <NavSep />
            <button className={`nav-item ${pagina === "utenti" ? "active" : ""}`} onClick={() => setPagina("utenti")}>
              <span>👥</span> Utenti
            </button>
            <button className={`nav-item ${pagina === "impostazioni" ? "active" : ""}`} onClick={() => setPagina("impostazioni")}>
              <span>⚙️</span> Impostazioni
            </button>
          </>)}
        </div>

        {/* Utente loggato */}
        <div className="sidebar-user">
          <div className="sidebar-user-name">{utente?.nome}</div>
          <span className="sidebar-user-role" style={{ background: badge.bg, color: badge.color }}>
            {utente?.ruolo}
          </span>
          <button className="btn-logout" onClick={logout}>Esci</button>
        </div>
      </nav>

      <main className="main-content">
        {pagina === "dashboard"    && <Dashboard />}
        {pagina === "nuovo"        && <NuovoPreventivo onSalvato={() => setPagina("archivio")} />}
        {pagina === "archivio"     && <Archivio onNuovo={() => puo("admin","dirigente","responsabile","venditore") && setPagina("nuovo")} utente={utente} />}
        {pagina === "approvazioni" && <Approvazioni />}
        {pagina === "catalogo"     && <Catalogo />}
        {pagina === "promozioni"   && <Promozioni />}
        {pagina === "profilo"      && <Profilo />}
        {pagina === "utenti"       && <GestioneUtenti />}
        {pagina === "impostazioni" && <Impostazioni />}
      </main>
    </div>
  );
}

export default function App() {
  return <AuthProvider><Shell /></AuthProvider>;
}
